module.exports = __webpack_public_path__ + "static/media/logo.e79b194a.png";